import { schema } from '@data-client/rest';
export function paginatedSchema(entity) {
    return {
        count: 0,
        items: new schema.Collection([entity])
    };
}
/**
 * Paginated encryption list with optional `ids` (encryptionGUIDs) from the API.
 * Client falls back to mapping `items` when `ids` is absent or empty.
 */
export function paginatedEncryptionListSchema(entity) {
    return {
        count: 0,
        items: new schema.Collection([entity]),
        ids: []
    };
}
